export const version = '0.46.21';
export const name = 'libp2p';
//# sourceMappingURL=version.js.map